module.exports = __webpack_public_path__ + "img/wealth-2.95975a67.png";